import React from "react";
import styles from "./swipeable-task-card.module.css";
import { Trans } from "@coworker/locales";
import SSRIcon from "@ingka/ssr-icon";
import checkmarkIcon from "@ingka/ssr-icon/paths/checkmark";
import pencilIcon from "@ingka/ssr-icon/paths/pencil";
import { useWorkspacesAction } from "@coworker/app/src/hooks/useWorkspaces";
import { useCompleteTask } from "@coworker/app/src/hooks/TaskActions/useCompleteTask";
import { Task } from "@coworker/types/lib/tasks/base";

interface CompleteButtonsProps {
  swipeDirection: string;
  setSwipeDirection: React.Dispatch<
    React.SetStateAction<"" | "left" | "right">
  >;
  isAddonTask: boolean;
  task: Task;
}

export const CompleteButtons = ({
  swipeDirection,
  setSwipeDirection,
  isAddonTask,
  task,
}: CompleteButtonsProps) => {
  const { push } = useWorkspacesAction();

  const { call: completeTask } = useCompleteTask(task, task.id, {
    undo: true,
    afterUndo: () => push(`/task/${task.id}`),
  });

  return (
    <div
      className={`${styles["complete-buttons"]} ${
        swipeDirection === "right"
          ? styles["complete-buttons-visible"]
          : styles["complete-buttons-hidden"]
      }`}
    >
      <div className={styles["complete-buttons-wrapper"]}>
        <div
          className={styles["button-complete"]}
          onClick={() => {
            completeTask();
            setSwipeDirection("");
          }}
        >
          <SSRIcon paths={checkmarkIcon} />
          <span className={styles["button-text"]}>
            <Trans>completeString</Trans>
          </span>
        </div>
        {isAddonTask && (
          <div
            className={styles["button-complete-with-changes"]}
            onClick={() => push(`/task/${task.id}/changes`, { picking: false })}
          >
            <SSRIcon paths={pencilIcon} />
            <span className={styles["button-text"]}>
              <Trans>completeWithChangesString</Trans>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
